import React, {useContext} from 'react'
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import FormTranslationContext from "context/FormTranslationContext";
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";


function TenderCompletionNotDivided(
    {
        id,
        formikProps,
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)

    return (<>

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("tenderCompletionType")}
            items={getDict("ENUM.003")}
            required
        />

        <Collapse in={gVal("tenderCompletionType") === "uniewaznienie"}>
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("legalBasisForWithdrawal")}
                items={getDict("SL.MO.020")}
                required
            />
        </Collapse>

        <Collapse in={gVal("tenderCompletionType") === "uniewaznienie"}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("justificationForWithdrawal")}
                multiple
            />
        </Collapse>

    </>)
}

TenderCompletionNotDivided.propTypes = {};

export default TenderCompletionNotDivided;
